import React from "react";
import TopNavigation from "components/ui/TopNavigation";
import Icon from "components/AppIcon";
import MemberRegistration from "../gym-owner-portal/components/MemberRegistration";

export default function GymOwnerMembers() {
  return (
    <div className="min-h-screen bg-[var(--color-background)]">
      <TopNavigation />
      <main>
        <div className="bg-[var(--color-card)] border-b border-[var(--color-border)] px-4 md:px-6 py-4">
          <div className="max-w-screen-2xl mx-auto">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-md bg-[var(--color-primary)]/15 flex items-center justify-center">
                <Icon name="Users" size={15} color="var(--color-primary)" />
              </div>
              <div>
                <h1 className="text-lg font-bold font-[var(--font-heading)] text-[var(--color-foreground)]">Members</h1>
                <p className="text-sm text-[var(--color-muted-foreground)] font-[var(--font-caption)]">Register and manage gym members</p>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-6">
          <MemberRegistration />
        </div>
      </main>
    </div>
  );
}
